import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { LoggingService } from '../services';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
    constructor(private loggingService: LoggingService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url === this.loggingService.serverLoggingUrl) {
            return next.handle(req);
        }

        if (this.loggingService.isDebugEnabled()) {
            this.loggingService.debug(`Request: ${req.method} ${req.url}`, {
                method: req.method,
                url: req.urlWithParams,
                responseType: req.responseType,
            });
        }

        return next.handle(req).pipe(
            tap({
                next: (event) => {
                    if (event instanceof HttpResponse) {
                        // this.loggingService.debug(`Response: ${req.url}`, event);
                    }
                },
                error: (error) => {
                    // this.loggingService.error(`Error from ${req.url}`, error);
                },
            })
        );
    }
}
